import { createTheme } from '@mui/material/styles';

// CSS custom properties are the shared source of visual values, including portals.
const uiSapTheme = createTheme({
  typography: { fontFamily: "Arial, 'Helvetica Neue', 'Segoe UI', sans-serif", fontSize: 12 },
  palette: {
    primary: { main: '#d94b0b' },
    secondary: { main: '#2563eb' },
    background: { default: '#f5f7fa', paper: '#ffffff' },
    text: { primary: '#4b535e', secondary: '#66758a' },
    divider: '#dce3eb',
  },
  shape: { borderRadius: 3 },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: { root: { textTransform: 'none', fontWeight: 600, minHeight: 36 } },
    },
    MuiTab: { styleOverrides: { root: { textTransform: 'none', minHeight: 42 } } },
    MuiTextField: { defaultProps: { size: 'small' } },
    MuiOutlinedInput: { styleOverrides: {
      root: { borderRadius: 2, minHeight: 30, fontSize: 12, backgroundColor: '#f4f5f7', '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderWidth: 1, borderColor: '#909cab' } },
      input: { padding: '5px 8px', '&:focus': { outline: 'none', boxShadow: 'none' } },
    } },
    MuiDialog: { styleOverrides: { paper: { borderRadius: 12 } } },
    MuiTooltip: { styleOverrides: { tooltip: { backgroundColor: '#17263c', fontSize: 12 } } },
    MuiDataGrid: { defaultProps: { rowHeight: 42, columnHeaderHeight: 42 } },
  },
});

export default uiSapTheme;
